<template>
  <div class="service-process-block">
    <img src="@/assets/imgs/service_graduate.jpg" />
  </div>
</template>

<script>
/**
 * @description 考研辅导-服务流程
 */
export default {
  name: 'ServiceProcess',
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.service-process-block {
  img {
    display: block;
    width: 100%;
  }
}
</style>